// Route-level identity for the brief currently open. Module-scoped so it
// survives re-renders without a context: only the route component knows
// these, and both the hook and the API adapter need them.
let briefIds = { bookingId: undefined, briefUuid: undefined };
// egadmin browsing the client's answers: everything renders, nothing writes.
let readOnlyMode = false;
// The server can say the same thing — a past round is history.
let payloadReadOnly = false;
// Ops reading a version before it is published: there is no booking and no
// brief behind the page, so nothing may be written anywhere.
let previewMode = false;

export const setSession = ({ bookingId, briefUuid, readOnly }) => {
  briefIds = { bookingId, briefUuid };
  readOnlyMode = !!readOnly;
};

/**
 * Set from the preview payload, and cleared when that route unmounts: the
 * flag is module-scoped, so a stale `true` would silently break the real form.
 */
export const setPreviewMode = (value) => {
  previewMode = !!value;
};

/** Set from the bootstrap response, which owns the snapshot case. */
export const setPayloadReadOnly = (value) => {
  payloadReadOnly = !!value;
};

// Accessors rather than exported bindings: both are reassigned, and consumers
// must see the current value, not the one captured at import.
export const getBriefIds = () => briefIds;
// Either source is enough to block every write.
export const isReadOnly = () => readOnlyMode || payloadReadOnly;
// Deliberately not folded into isReadOnly: read-only greys the controls out,
// and a preview needs them live so ops can click through the form.
export const isPreview = () => previewMode;
